(function () {
  var BODY_CLASS = 'hide-chat-rewards-button';
  var TEASER_CLASS = 'hide-redo-teaser';
  var AWAY_CLASS = 'bb-launchers-away';

  var selectors = [
    'cart-drawer.active',
    '.qv-overlay.is-open',
    '.nsc-overlay.is-open',
    '#bbh-drawer.is-open',
    'body.bbh-lock',
    'n-collection.is-drawer-open',
    'n-collection [data-ncl-sort].is-open',
  ];

  var queued = false;
  var redoRoot = null;

  // The Redo discount pop-up renders inside its own shadow root, which the
  // document-level observer can't see into, so that root gets its own observer.
  // The dialog is removed from the DOM when the pop-up closes.
  function isRedoPopupOpen() {
    var host = document.getElementById('redo-spotlight-container');
    var root = host && host.shadowRoot;
    if (root && root !== redoRoot) {
      redoRoot = root;
      new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    }
    return !!(root && root.querySelector('[role="dialog"][aria-modal="true"]'));
  }

  function isPanelOpen() {
    for (var i = 0; i < selectors.length; i++) {
      if (document.querySelector(selectors[i])) return true;
    }
    return false;
  }

  function sync() {
    queued = false;
    if (!document.body) return;
    var panelOpen = isPanelOpen();
    var popupOpen = isRedoPopupOpen();
    document.body.classList.toggle(BODY_CLASS, panelOpen || popupOpen);
    // Redo's "Get 20% off" teaser shares a container with its pop-up (which also
    // holds the back-in-stock "Notify" form opened from the quick view), so that
    // container is hidden for the theme's own panels only, never while a Redo
    // pop-up is open: hiding it would leave an invisible dialog that still locks
    // the page.
    document.body.classList.toggle(TEASER_CLASS, panelOpen && !popupOpen);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }

  /* Collection pages: the launchers step aside (AWAY_CLASS) while the shopper
     scrolls down through the product grid, and come back on scroll up or once
     the grid has left the band at the bottom of the screen where they sit
     (the hero at the top, the footer at the end). */
  var GRID_SELECTOR = 'n-collection, #ProductGridContainer';
  var LAUNCHER_ZONE = 260;
  var SCROLL_THRESHOLD = 8;
  var lastY = 0;
  var scrollQueued = false;

  function gridUnderLaunchers() {
    var grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return false;
    var rect = grid.getBoundingClientRect();
    var vh = window.innerHeight;
    return rect.top < vh && rect.bottom > vh - LAUNCHER_ZONE;
  }

  function updateAway() {
    scrollQueued = false;
    var y = window.scrollY;
    var delta = y - lastY;
    if (Math.abs(delta) < SCROLL_THRESHOLD) return;
    lastY = y;
    document.body.classList.toggle(AWAY_CLASS, delta > 0 && gridUnderLaunchers());
  }

  function onScroll() {
    if (scrollQueued) return;
    scrollQueued = true;
    requestAnimationFrame(updateAway);
  }

  function start() {
    sync();
    new MutationObserver(schedule).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    if (document.body.classList.contains('page-collection') && document.querySelector(GRID_SELECTOR)) {
      lastY = window.scrollY;
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  window.rewardsChatLocker = {
    selectors: selectors,
    sync: sync,
    watch: function (selector) {
      if (selectors.indexOf(selector) === -1) selectors.push(selector);
      schedule();
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
